import { SupportWidgetSettingsPanel } from '../../supportWidget/SupportWidgetSettingsPanel';

export function SettingsSupportPage() {
  return <SupportWidgetSettingsPanel />;
}
